// extracted by mini-css-extract-plugin
export var columnList = "_by-0";